module.exports = __webpack_public_path__ + "img/car_track.13efffc1.png";